import React from 'react'
import PropTypes from 'prop-types'

import Button from '../../../../../components/Button'

import './styles.css'

function DashboardCompletedFilterForm({ onSubmit, submitText, invalid, children }) {

    const submit = (e) => {
        e.preventDefault()
        onSubmit(e)
    }

    return (
        <form
            className="DashboardCompletedFilterForm"
            onSubmit={submit}
        >
            {children}
            <div className="DashboardCompletedFilterForm__action-bar">
                <Button
                    disabled={invalid}
                    skin="primary"
                    type="submit"
                    text={submitText}
                />
            </div>
        </form>
    )
}

DashboardCompletedFilterForm.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    submitText: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
}

export default DashboardCompletedFilterForm
